import React from 'react';
import SvgIcon from './SvgIcon';
import { SvgIconProps } from './types';

const TelavoxIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox={'0 0 24 24'}>
        <g
            id="Telavox_Bug"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <g id="Group">
                <path
                    d="M12,12.48 C9.08404406,12.48 6.72,14.8438994 6.72,17.7603231 C6.72,20.6761006 9.08404406,23.04 12,23.04 C14.9166022,23.04 17.28,20.6761006 17.28,17.7603231 C17.28,14.8438994 14.9166022,12.48 12,12.48 L12,12.48 Z"
                    id="Path"
                    fill="#ffffff"
                />
                <path
                    d="M24,5.28032142 C24,2.36373775 21.5935225,0 18.6256645,0 L5.3736812,0 C2.40582318,0 0,2.36373775 0,5.28032142 C0,8.1969051 2.40582318,10.56 5.3736812,10.56 L18.6256645,10.56 C21.5935225,10.56 24,8.1969051 24,5.28032142 L24,5.28032142 Z"
                    id="Path"
                    fill="#2DC659"
                />
            </g>
        </g>
    </SvgIcon>
);

export default TelavoxIcon;
